/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import './portalHome.css'
import { UserContext } from '../context/userContext';
import { TextField } from '@mui/material';

function ForgotPassword() {
    const { resetPassword } = useContext(UserContext);
    const [errorMessage, setErrorMessage] = useState()
    const [email, setEmail] = useState()



const sendPasswordResetEmail = (emailAddress) => {
    try{
        resetPassword(emailAddress)
    }
    catch(e){
        setErrorMessage(e)
    }
}

  return (
      <Container classNmae='justify-content-md-center' style={{height:"100vh",color:"white", backgroundColor:"#091440", backgroundPosition:"top"}} fluid>
            <Row className='mb-3 justify-content-md-center' style={{height:"90vh", paddingTop:10, paddingBottom:10}}>
                <Col md={3}>
                    <Card>
                        <Card.Body>
                            <Card.Title>
                            Forgot your password?
                            </Card.Title>
                            <Card.Text>
                                Enter your email below and a password reset should be sent to you shortly
                                <TextField
                sx={{ width: "100%", marginTop:5 }}
                id="outlined-basic"
                label="Email Address"
                variant="outlined"
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                }} />
                <p className="text-danger mt-1">{errorMessage}</p>
                            </Card.Text>
                            <Button onClick={() => sendPasswordResetEmail(email)}>Reset Password</Button>
                        </Card.Body>
                        
                    </Card>
                </Col>
          </Row>
      </Container>
  );
}

export default ForgotPassword